import reducer, { initState } from './application.reducers';

export { initState };

export default reducer;
